import config from "src/config";
import {ResponseDto} from "src/dtos/common/responseDto";
import {getData} from "src/utils/axios/serverHelper";
import {formatDate} from "src/utils/string/stringUtil";
import {EQM1020_R01Dto} from "./Dto_EQM1020_R01";
import {EQM1020_R01Filter} from "./Store_EQM1020_R01";

const baseUrl = `${config.apiUrl}/EQM1020_R01`;

/**
 * EQM1020_R01 - 설비데이타 수집 분단위 집계 조회 API
 */

/**
 * Filter를 API 파라미터로 변환
 */
export const getParams = (filter: EQM1020_R01Filter) => {
    // baseDate를 사용하여 startDate와 endDate를 같은 날짜로 설정
    const formattedDate = filter.baseDate ? formatDate(filter.baseDate) : undefined;

    return {
        compCd: filter.compCd || undefined,
        startDate: formattedDate,
        endDate: formattedDate,
        plcaddressid: filter.plcaddressid ?? undefined,
    };
};

/**
 * 분단위 집계 데이터 조회
 * @param option - 'refetch' 또는 빈 문자열
 * @param filter - 조회 조건
 * @param listLength - 조회 건수 제한
 */
export const getEQM1020_R01List = async (
    option: string = '', 
    filter: EQM1020_R01Filter, 
    listLength: number = 0
) => {
    const url = option ? `${baseUrl}/${option}` : baseUrl;
    
    const params = {
        ...getParams(filter),
        listLength: listLength || undefined,
    };
    
    return await getData<ResponseDto<EQM1020_R01Dto[]>>(url, { params });
};

/**
 * 엑셀 다운로드
 * @param option - 'search' 또는 빈 문자열
 * @param filter - 조회 조건
 * @param listLength - 조회 건수 제한
 */
export const exportEQM1020_R01Excel = async (
    option: string = '', 
    filter: EQM1020_R01Filter, 
    listLength: number = 0
) => {
    const url = option ? `${baseUrl}/excel/${option}` : `${baseUrl}/excel`;
    
    const params = {
        ...getParams(filter),
        listLength: listLength || undefined,
    };
    
    return await getData<ResponseDto<string>>(url, { params });
};
